import beneficiary from "./beneficiary";
import cases from "./cases";
import { combineReducers } from "@reduxjs/toolkit";
import consent from "./consent";
import interview from "./interview";
import physician from "./physician";
import signing from "./signing";
import singleCase from "./singleCase";
import { downtime } from "./downtime";

const rootReducer = combineReducers({
  interview,
  physician,
  cases,
  singleCase,
  consent,
  signing,
  beneficiary,
  downtime,
});

export type ReduxState = ReturnType<typeof rootReducer>;
export default rootReducer;
